import { ComparedValueEntity } from './media.entity'

export class ChatChannelEntity {
  name!: string
  messages!: ComparedValueEntity
  active_users!: ComparedValueEntity
  unique_chatters!: ComparedValueEntity
}

export class ChatPeriodEntity {
  date!: string
  messages!: number
  active_users!: number
  unique_chatters!: number
}

export class ChatTotalsEntity {
  messages!: ComparedValueEntity
  active_users!: ComparedValueEntity
  unique_chatters!: ComparedValueEntity
  periods!: ChatPeriodEntity[]
}
